module.exports = __webpack_public_path__ + "static/media/spark.42bd757b.png";